<template>
  <div style="height: 100vh" v-if="dashboard">
    <div
    style="
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-direction: column;
        "
    >
      <vs-button style="align-self: flex-end;" @click="$router.push('/')">SALIR</vs-button>
      <iframe
        :src="dashboard"
        frameborder="0"
        style="
          height: 92%;
          width: 97%;
          border-radius: 20px;
          box-shadow: 0px 15px 20px #453f3f;
        "
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: 'queues',
      dashboard: '',
    };
  },
  async mounted() {
    const url = process.env.VUE_APP_JACKPOT_API;
    const token = localStorage.getItem('tokenSession');

    if (!url || !token) return;

    this.dashboard = `${url}queues?token=${token}`;
    console.log('dashboard', this.dashboard);
  },
};
</script>

<style lang="scss" scoped></style>
